module.exports = __webpack_public_path__ + "static/media/seguros-mundial-survey-experience.d1176238.svg";